// extracted by mini-css-extract-plugin
export default {"container":"toggle-button_container___HLTo","togglerLabel":"toggle-button_togglerLabel__294V9","closeIcon":"toggle-button_closeIcon__2zSpL","opened":"toggle-button_opened__2S4A5"};